
/* global React */

import React  from 'react';
import ReactDOM from 'react-dom';

class CheckboxGroup extends React.Component {
  constructor (props) {
    super(props)
    this.state ={
        defaultValue: this.props.defaultValue || []
    };
  }

  componentDidMount = () => {
    this.setCheckboxNames();
    this.setCheckedBoxes();
  }

  componentDidUpdate = () => {
    this.setCheckboxNames();
    this.setCheckedBoxes();
  }

  render = () => {
    return React.createElement(
      'div',
      this.props,
      this.props.children
    );
  }

  setCheckboxNames = () => {
    // stay DRY and don't put the same `name` on all checkboxes manually. Put it on
    // the tag and it'll be done here
    var $checkboxes = this.getCheckboxes();
    for (var i = 0, _length = $checkboxes.length; i < _length; i++) {
      $checkboxes[i].setAttribute('name', this.props.name);
    }
  }

  getCheckboxes = () => {
    return ReactDOM.findDOMNode(this).querySelectorAll('input[type="checkbox"]');
  }

  setCheckedBoxes = () => {
    var $checkboxes = this.getCheckboxes();
    // if `value` is passed from parent, always use that value. This is similar
    // to React's controlled component. If `defaultValue` is used instead,
    // subsequent updates to defaultValue are ignored. Note: when `defaultValue`
    // and `value` are both passed, the latter takes precedence, just like in
    // a controlled component
    var destinationValue = this.props.value !== null ? this.props.value : this.state.defaultValue;

    for (var i = 0, _length2 = $checkboxes.length; i < _length2; i++) {
      var $checkbox = $checkboxes[i];

      // intentionally use implicit conversion for those who accidentally used,
      // say, `valueToChange` of 1 (integer) to compare it with `value` of "1"
      // (auto conversion to valid html value from React)
      if (destinationValue.indexOf($checkbox.value) >= 0) {
        $checkbox.checked = true;
      }
    }
  }

  getCheckedValues = () => {
    var $checkboxes = this.getCheckboxes();

    var checked = [];
    for (var i = 0, _length3 = $checkboxes.length; i < _length3; i++) {
      if ($checkboxes[i].checked) {
        checked.push($checkboxes[i].value);
      }
    }

    return checked;
  }

  getUncheckedValues = () => {
    var $checkboxes = this.getCheckboxes();

    var unchecked = [];
    for (var i = 0, _length3 = $checkboxes.length; i < _length3; i++) {
      if (!$checkboxes[i].checked) {
        unchecked.push($checkboxes[i].value);
      }
    }

    return unchecked;
  }

}

export default CheckboxGroup;
